
    import { defineComponent } from 'vue'
    import Dialog from 'primevue/dialog'
    import workspaceRepositoryMoveDialogDescriptor from './WorkspaceRepositoryMoveDialogDescriptor.json'
    import WorkspaceDocumentTree from '../../../genericComponents/WorkspaceDocumentTree.vue'

    export default defineComponent({
        name: 'workspace-repository-move-dialog',
        components: { Dialog, WorkspaceDocumentTree },
        props: { visible: { type: Boolean }, propFolders: { type: Array } },
        emits: ['close', 'move'],
        data() {
            return {
                workspaceRepositoryMoveDialogDescriptor,
                folders: [] as any[],
                selectedFolder: null as any
            }
        },
        watch: {
            propFolders() {
                this.loadFolders()
            }
        },
        created() {
            this.loadFolders()
        },
        methods: {
            loadFolders() {
                this.folders = this.propFolders as any[]
            },
            closeDialog() {
                this.selectedFolder = null
                this.$emit('close')
            },
            moveDocument() {
                this.$emit('move', this.selectedFolder)
            },
            setSelectedFolder(folder: any) {
                this.selectedFolder = folder
            }
        }
    })
